import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MILogo from "../../images/MI-Image.png";
import axios from "axios";
import Loading from "../../utlis/Loading";

const MPUCheckoutForm = () => {
  const [searchParams] = useSearchParams();
  const paymentToken = searchParams.get("paymentToken");
  const [responseData, setResponseData] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    sendTransaction();
  }, []);

  const sendTransaction = async () => {
    if (!paymentToken) {
      setMessage("Missing token");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/card/mpu`,
        null,
        { params: { token: paymentToken } }
      );

      const fields = res.data;
      console.log("RESPONSE DATA: ", fields);

      setResponseData(fields);
    } catch (e) {
      console.error(e);
      setMessage("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  const submitMPUForm = async () => {
    const form = document.createElement("form");
    form.method = "POST";
    // form.action = "https://www.mpuecomuat.com/UAT/Payment/Payment/pay";
    form.action = "https://www.mpu-ecommerce.com/Payment/Payment/pay";

    form.style.display = "none";

    delete responseData.serviceFee;
    delete responseData.realAmount;

    Object.entries(responseData).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="container mt-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img
            src={MILogo}
            alt="Logo"
            className="me-2"
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>

      {/* Payment Section */}
      <div className="mt-3">
        <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>

        <div className="table-responsive">
          <table className="table" style={{ fontSize: "16px", width: "auto" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "55%",
                    fontWeight: "bold",
                  }}
                  className="text-start"
                >
                  Total Amount :
                </td>
                <td className="text-end" style={{ fontWeight: "bold" }}>
                  {(
                    Number(responseData?.realAmount) +
                      Number(responseData?.serviceFee) || 0
                  ).toLocaleString("en-US") + " MMK"}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Transaction Amount :
                </td>
                <td className="text-end">
                  {(Number(responseData?.realAmount) || 0).toLocaleString(
                    "en-US"
                  ) + " MMK"}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Service Fee :
                </td>
                <td className="text-end">
                  {(responseData?.serviceFee - 0).toLocaleString("en-US") +
                    " MMK"}
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }} className="text-start">
                  Invoice No. :
                </td>
                <td className="text-end">{responseData?.invoiceNo}</td>
              </tr>
            </tbody>
          </table>
          {/* </div> */}
        </div>
      </div>

      <div className="container mt-4">
        <h5>MPU Card Payment</h5>
        <div
          className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center"
          style={{ minHeight: "30vh", padding: "1rem" }}
        >
          <div className="d-flex flex-column flex-md-row w-100 w-md-auto">
            <button
              className="btn btn-primary mx-0 mx-md-2"
              onClick={() => submitMPUForm()}
            >
              Submit Payment
            </button>
          </div>

          {message && <div className="mt-3 w-100">{message}</div>}
        </div>
      </div>
    </div>
  );
};

export default MPUCheckoutForm;
